export default [
    {
        path: 'relatorio-requisicao',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-relatorio-requisicao' */
            '@/views/almoxarifado/relatorio-requisicao/Index'
        ),
        redirect: 'relatorio-requisicao/index',
        children: [
            {
                name: 'almoxarifado-relatorio-requisicao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-relatorio-requisicao' */
                    '@/views/almoxarifado/relatorio-requisicao/List.vue'
                ),
            },
        ],
    },
]